import { HttpModelConverter } from "src/app/modules/core/converter/httpModel.converter";
import { Injectable } from "@angular/core";
import { CommunicationConfigurationEmailSenderSummaryModel } from "../communicationConfigurationEmailSenderSummary.model";
import {UserSummaryConverter} from "src/app/modules/account/modules/user/api/converter/userSummary.converter";
@Injectable({
    providedIn: "root"
})
export class CommunicationConfigurationEmailSenderSummaryConverter extends HttpModelConverter<CommunicationConfigurationEmailSenderSummaryModel> {
    constructor(private userSummaryConverter: UserSummaryConverter) {
        super();
    }
    protected createInstance(): CommunicationConfigurationEmailSenderSummaryModel {
        return new CommunicationConfigurationEmailSenderSummaryModel();
    }
    protected enrichObject(result: CommunicationConfigurationEmailSenderSummaryModel, src: CommunicationConfigurationEmailSenderSummaryModel): void {
        result.owner = this.userSummaryConverter.convert(src.owner);
    }
}